import { useEffect, useState } from "react";

/**
 * Returns true only after `delay` ms have passed with loading=true.
 * Fast loads (< delay) never trigger a visible loading state.
 */
export function useDelayedLoading(loading: boolean, delay = 150): boolean {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!loading) { setShow(false); return; }
    const timer = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(timer);
  }, [loading, delay]);

  return show;
}
